import { Developer } from './developers';
import { Skill } from './profile';

export enum ProjectsListType {
  MY_PROJECTS_CURRENT_OFFERS = 'MY_PROJECTS_CURRENT_OFFERS',
  MY_PROJECTS_ACCEPTED = 'MY_PROJECTS_ACCEPTED',
  MY_PROJECTS_CANCELED = 'MY_PROJECTS_CANCELED',
  HOT_PROJECTS = 'HOT_PROJECTS',
  RECENTLY_CLOSED = 'RECENTLY_CLOSED',
}

export interface ProjectQuestion {
  id: string;
  title: string;
  order?: number;
}

export interface ProjectAnswer {
  hubspotProjectQuestionId?: string;
  text: string;
  originalQuestionTitle?: string;
  isHidden?: boolean;
}

export interface ProjectApplicationSumbitResults {
  readyToStartAt?: string;
  vacationPlans?: string;
  interviewTimeslots?: string;
  workingHoursFrom?: string;
  workingHoursTo?: string;
  timeZone?: string;
  candidateApplicationComment?: string;
}

export enum HubspotHireType {
  Contractor = 'Contractor',
  ContractorDirectHireLater = 'Contractor, direct hire later',
  DirectHireNowOrLater = 'Direct hire right away or after trial',
  DontKnowYet = "Don't know yet",
}

export enum ProjectOfferStatus {
  NewOffer = 'NewOffer',
  ApplicationSubmitted = 'ApplicationSubmitted',
  WaitingForReview = 'WaitingForReview',
  UnderReview = 'UnderReview',
  OfferAccepted = 'OfferAccepted',
  OfferDeclined = 'OfferDeclined',
  OfferDeclinedByDev = 'OfferDeclinedByDev',
  OfferDeclinedOnClientSuccessStage = 'OfferDeclinedOnClientSuccessStage',
}

export interface ProjectSkill {
  id: string;
  years: number | null;
  name: string;
  main: boolean;
}

export enum ProjectPublishStatus {
  Published = 'Published',
  Unpublished = 'Unpublished',
}

export enum ProjectSearchStatus {
  Searching = 'Searching',
  Completed = 'Completed',
}

export enum DealStage {
  OfferMade = 'OfferMade',
  NewRequests = 'NewRequests',
  MatchPlease = 'MatchPlease',
  MatchReady = 'MatchReady',
  ClosedLost = 'ClosedLost',
  ClosedWon = 'ClosedWon',
  Qualification = 'Qualification',
  Negotiation = 'Negotiation',
  OutForSignature = 'OutForSignature',
  Other = 'Other',
}

export enum ApplicationState {
  Offered = 'Offered',
  OfferDeclined = 'OfferDeclined',
  OfferCancelled = 'OfferCancelled',
  InReview = 'InReview',
  WithMatching = 'WithMatching',
  UnderClientReview = 'UnderClientReview',
  Accepted = 'Accepted',
  NotSelected = 'NotSelected',
  Withdrawn = 'Withdrawn',
  ProjectClosed = 'ProjectClosed',
}

export enum ProjectPositionDecision {
  Pending = 'Pending',
  Pass = 'Pass',
  Reject = 'Reject',
  NeedsMoreEvidence = 'NeedsMoreEvidence',
  NeedsReReview = 'NeedsReReview',
}

export enum ProjectDeclineStage {
  Recruiting = 'Recruiting',
  Matching = 'Matching',
  Sales = 'Sales',
  ClientSuccess = 'Client Success',
}

export interface Project extends ProjectApplicationSumbitResults {
  id: string;
  dealId: string;
  applicationProjectDealId?: string;
  contactId: string;

  projectMustHaveSkills?: ProjectSkill[];
  projectNiceToHaveSkills?: ProjectSkill[];

  projectQuestions?: ProjectQuestion[];
  projectAnswers?: ProjectAnswer[];
  hasCandidateConfirmedApplication?: boolean;
  appliedAt?: string | null;
  isApplicationAccepted?: boolean;
  positionDecision?: ProjectPositionDecision;
  declineStage?: ProjectDeclineStage;
  desiredRateMin?: number | null;
  desiredRateMax?: number | null;
  candidateRateComment?: string | null;
  slackURL?: string;

  projectName?: string;
  projectDescription?: string;
  projectTeamCommunication?: string;
  projectDevTeamSize?: string;
  projectExpectedEngagementDuration?: string;
  projectPreferredStartDate?: string;
  projectRequiredOverlap?: string;
  projectClientTimeZone?: string;
  projectProjectTechStack?: string;
  projectSelectionProcess?: string;
  candidateRatePerHour?: string | number;
  rateCommentForDev?: string;
  projectInvolvementType?: string;
  projectWeeklyInvolvement?: string;
  dateProjectCreated?: string;
  offerStatus?: ProjectOfferStatus;
  declineFeedback?: string;
  projectMustBeAvailableForDirectHire?: boolean;
  projectTypeOfHire?: HubspotHireType;
  projectSoftSkills?: string[];
  projectSoftSkillsDetailed?: string;
  projectGoal?: string;
  projectAssigneeName?: string;
  projectPublishStatus?: ProjectPublishStatus;
  dealStage?: DealStage;
  projectSearchStatus?: ProjectSearchStatus | null;
  isSearchOpen?: boolean;
  hiringPositionId?: string | null;
  hiringPositionRole?: string | null;
  hiringPositionRoleKey?: string | null;
  contactRoleId?: string | null;

  partnerDeveloper?: Developer & { mainSkills: Array<Skill> };
}
